<template>
  <div class="m-5">
    <div v-if="detail == false">
      <vs-button
        v-if="status == 1"
        class="mt-2"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-plus"
        @click="handleCreate()"
        >Create</vs-button
      >
    </div>
    <div class="vx-row mb-12">
      <div v-if="detail == false" class="w-full">
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ this.table.start }} - {{ this.table.end }} of
                  {{ this.table.total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangelength(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th sort-key="code">Action</vs-th>
            <vs-th sort-key="code">CL Request ID</vs-th>
            <vs-th>Type</vs-th>
            <vs-th sort-key="name">Customer Code</vs-th>
            <vs-th sort-key="valid_from">Current CL/TOP</vs-th>
            <vs-th sort-key="valid_to">Request CL/TOP</vs-th>
            <vs-th sort-key="updated_at">Valid From</vs-th>
            <vs-th sort-key="updated_by">Reason</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <template class="flex">
                  <vx-tooltip text="Edit" v-if="status == 1 || status == 3">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="ml-4"
                      @click="clickEdit(tr)"
                    />
                  </vx-tooltip>
                  <vx-tooltip
                    text="View"
                    v-if="
                      status == 2 || status == 4 || status == 5 || status == 6
                    "
                  >
                    <feather-icon
                      icon="EyeIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="ml-4"
                      @click="clickView(tr)"
                    />
                  </vx-tooltip>
                  <vx-tooltip text="Cancel" v-if="status == 1 || status == 3">
                    <feather-icon
                      icon="XIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="ml-4"
                      @click="clickCancel(tr)"
                    />
                  </vx-tooltip>
                  <vx-tooltip text="Accept" v-if="status == 1 || status == 3">
                    <feather-icon
                      icon="CheckIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="ml-4"
                      @click="clickAccept(tr)"
                    />
                  </vx-tooltip>
                </template>
              </vs-td>
              <vs-td :data="data[indextr].code">{{ data[indextr].code }}</vs-td>
              <vs-td :data="data[indextr].type">{{
                data[indextr].payment_term &&
                !data[indextr].credit_limit_request
                  ? "TOP"
                  : data[indextr].payment_term &&
                    data[indextr].credit_limit_request
                  ? "ALL"
                  : "CL"
              }}</vs-td>

              <vs-td :data="data[indextr].customer_code">{{
                data[indextr].customer_code
              }}</vs-td>
              <vs-td>
                {{
                  data[indextr].current_credit_limit
                    ? data[indextr].current_credit_limit
                    : 0
                }}
                /
                {{
                  data[indextr].current_payment_term
                    ? data[indextr].current_payment_term
                    : "-"
                }}
              </vs-td>
              <vs-td>
                {{
                  data[indextr].credit_limit_request
                    ? data[indextr].credit_limit_request
                    : "-"
                }}
                /
                {{
                  data[indextr].payment_term ? data[indextr].payment_term : "-"
                }}
              </vs-td>
              <vs-td :data="data[indextr].valid_from">{{
                data[indextr].valid_from | formatDate
              }}</vs-td>
              <vs-td :data="data[indextr].reason">{{
                data[indextr].reason
              }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
        />
      </div>
      <!-- form -->
      <transition name="detail-fade">
        <div v-if="detail" class="w-full">
          <div>
            <!-- form component -->
            <form-component
              v-if="isEdit == false && isShow == false"
              @close="handleClose"
              :id="id"
              :url="baseUrl"
            ></form-component>
            <edit
              v-if="isEdit == true && isShow == false"
              @close="handleClose"
              :id="id"
              :url="baseUrl"
              :title="title"
            ></edit>
            <show
              v-if="isShow == true"
              @close="handleClose"
              :id="id"
              :url="baseUrl"
              :title="title"
            ></show>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import FormComponent from "../form/form.vue";
import Edit from "../form/formEdit.vue";
import Show from "../form/formShow.vue";

export default {
  name: "list-credit-risk",
  props: {
    selected: Object,
    status: Number,
    filterData: {
      type: Object,
      default: () => ({
        selectedCustomer: [],
        selectedCustomerCategory: [],
        filterDate: {
          startDate: null,
          endDate: null,
        },
      }),
    },
  },
  components: {
    FormComponent,
    Edit,
    Show,
  },

  data() {
    return {
      baseUrl: "/api/v1/master/payment-term",
      detailShow: "core vx-col md:w-1/2 w-1/2 mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      detail: false,
      deleteId: null,
      id: null,
      isEdit: false,
      isShow: false,
      table: this.tableDefaultState(),
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        status: null,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.detail = false;
      this.$emit("showDetail", false);
    },
    handleCreate() {
      this.id = null;
      this.detail = true;
      this.isEdit = false;
      this.$emit("showDetail", true);
    },
    getData() {
      this.$vs.loading();
      if (this.status) {
        this.table.status = this.status;
      }

      const terr_id =
        this.$store.getters["operatingUnit/getSelectedTerritoryId"];
      let cust_id = [];
      if (
        this.filterData.selectedCustomer &&
        this.filterData.selectedCustomer.length > 0
      ) {
        if (this.filterData.selectedCustomer[0].id != 0) {
          cust_id = this.filterData.selectedCustomer.map(
            (element) => element.id
          );
        }
      }

      this.$http
        .get("/api/v1/master/credit-limit-requests", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            status: this.table.status,
            territory_id: terr_id,
            customer_id: cust_id,
            start_date:
              this.filterData.filterDate && this.filterData.filterDate.startDate
                ? moment(this.filterData.filterDate.startDate).format(
                    "YYYY-MM-DD"
                  )
                : null,
            end_date:
              this.filterData.filterDate && this.filterData.filterDate.endDate
                ? moment(this.filterData.filterDate.endDate).format(
                    "YYYY-MM-DD"
                  )
                : null,
          },
        })
        .then((resp) => {
          this.table.data = resp.data.records;
          this.table.total = resp.data.total_record;
          this.table.totalPage = resp.data.total_page;
          this.table.totalSearch = resp.data.total_record_search;
          this.table.length = resp.data.total_record_per_page;
          this.setStartEnd();
          this.$vs.loading.close();
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch != 0) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },

    clickEdit(item) {
      this.id = item.id;
      this.detail = true;
      this.isEdit = true;
      this.$emit("showDetail", true);
    },
    clickView(item) {
      this.id = item.id;
      this.detail = true;
      this.isShow = true;
      this.$emit("showDetail", true);
    },
    clickCancel(item) {
      this.$vs.loading();
      this.$http
        .post("/api/v1/master/credit-limit-requests/status", {
          id: item.id,
          status: 6,
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Data has been updated",
              color: "success",
              iconPack: "feather",
              position: "top-right",
              icon: "icon-check",
            });
            this.getData();
          }
        });
    },
    clickAccept(item) {
      this.$vs.loading();
      let instatus;
      if (this.status == 1) {
        instatus = 2;
      } else if (this.status == 2) {
        instatus = 4;
      } else if (this.status == 3) {
        instatus = 2;
      } else if (this.status == 5) {
        instatus = 3;
      }
      this.$http
        .post("/api/v1/master/credit-limit-requests/status", {
          id: item.id,
          customer_id: item.customer_id,
          status: instatus,
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Success",
              text: "Data has been updated",
              color: "success",
              iconPack: "feather",
              position: "top-right",
              icon: "icon-check",
            });
            this.getData();
          } else {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error",
              text: "Data failed to update, please check settings and try again",
              color: "danger",
              iconPack: "feather",
              position: "top-right",
              icon: "icon-x",
            });
          }
        });
    },
  },
  watch: {
    filterData: {
      handler(newVal, oldVal) {
        // Reload data when filter changes
        this.getData();
      },
      deep: true,
      immediate: true, // Call immediately when component is created with initial filterData
    },
  },
  mounted() {
    // Removed getData() call from mounted to prevent double loading
    // Data loading is now handled by filterData watcher with immediate: true
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
  },
};
</script>

<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>
